import {
  ADD_TO_TROLLEY_DESCRIPTION,
  REMOVE_FROM_TROLLEY_DESCRIPTION,
} from 'redux/middleware/analytics/actions-to-track/trolley/constants';
import changeCartTransform from './change-cart';
import type { Analytics } from './types';

const updateCartTransform = (state: WtrState, { analytics }: { analytics: Analytics }) => {
  if (analytics.decrement) {
    return changeCartTransform(state, [{ analytics }], 'remove', REMOVE_FROM_TROLLEY_DESCRIPTION);
  }

  return changeCartTransform(state, [{ analytics }], 'add', ADD_TO_TROLLEY_DESCRIPTION);
};

export default updateCartTransform;
